import React, { useState } from "react";
import {
  Title,
  GoBack,
  Message,
  TextArea,
  InputField,
  ActionButton,
} from "../../component/Component";
import { codeOk, errorMessage } from "../../../../middlewares/index";
import { useEthnicGroupContext } from "../../../../context/ethnicGroup/EthnicGroupContext";
import { getOneEthnicGroup } from "../../../../middlewares/sysNavigation/SysNavigation";

const Edit = () => {
  const { updateEthnicGroupState, updateEthnicGroup } = useEthnicGroupContext();
  const ethnicGroup = getOneEthnicGroup();

  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const ethnic_group_id = ethnicGroup.ethnic_group_id;
  const [name, setName] = useState(ethnicGroup.name);
  const [description, setDescription] = useState(ethnicGroup.description);

  const ethnicGroupRoutes = "/ethnic/group";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError, _status, _message) => {
    setError(isError);
    setStatus(_status);
    setErrorMessage(_message);
  };

  const updateOneEthnicGroupHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = { name, description };
    const response = await updateEthnicGroup(ethnic_group_id, data);

    if (response) {
      if (response.data.status === codeOk) {
        updateEthnicGroupState({ ethnic_group_id, ...data });
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <div className="p-4 lg:p-6 h-full overflow-y-auto bg-gray-50">
      <div className="max-w-4xl mx-auto">
        {/* Top bar */}
        <div className="flex items-center justify-between mb-4">
          <GoBack props={{ route: ethnicGroupRoutes }} />
          <span className="hidden sm:inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
            Editing
          </span>
        </div>

        {/* Alerts */}
        <div className="mb-4">
          <Message
            props={{
              error,
              success,
              message,
              loading,
              status,
              onClick: () => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              },
            }}
          />
        </div>

        {/* Form card */}
        <form onSubmit={updateOneEthnicGroupHandler}>
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            {/* Card header */}
            <div className="flex items-center justify-between px-5 py-4">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-100 text-sky-600">
                  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
                    <path d="M16 11a4 4 0 10-3.999-4.001A4 4 0 0016 11zM8 13a4 4 0 10-3.999-4.001A4 4 0 008 13zM16 13c-2.67 0-8 1.336-8 4v1a1 1 0 001 1h14a1 1 0 001-1v-1c0-2.664-5.33-4-8-4zM8 15c-2.4 0-7 1.202-7 3.6V20a1 1 0 001 1h8.05A5.8 5.8 0 018 19v-1c0-1.14.53-2.066 1.41-2.82C9.01 15.06 8.5 15 8 15z" />
                  </svg>
                </span>
                <div>
                  <Title props={{ title: "Ethnic Group Details" }} />
                  <p className="mt-0.5 text-xs text-gray-500">
                    Update the name and description, then save changes.
                  </p>
                </div>
              </div>
            </div>

            <div className="h-px bg-gray-100" />

            {/* Card body */}
            <div className="px-5 py-5">
              <div className="grid grid-cols-1 gap-4">
                <InputField
                  props={{
                    id: "title",
                    title: "Name",
                    type: "text",
                    required: true,
                    value: name ? name : "",
                    onChange: (e) => {
                      setName(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />

                <TextArea
                  props={{
                    id: "description",
                    title: "Description",
                    type: "text",
                    required: true,
                    value: description ? description : "",
                    onChange: (e) => {
                      setDescription(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>
            </div>

            <div className="h-px bg-gray-100" />

            {/* Card footer */}
            <div className="px-5 py-4 flex items-center justify-end">
              <ActionButton
                props={{
                  title: `Save Changes`,
                  error,
                  success,
                  message,
                  loading,
                  status,
                  onClick: () => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage("");
                  },
                }}
              />
            </div>
          </div>

          <p className="mt-3 text-xs text-gray-500">
            Changes apply immediately after saving.
          </p>
        </form>
      </div>
    </div>
  );
};

export default Edit;
